<script setup>
import { ref, reactive, getCurrentInstance } from "vue";
import HeaderComponent from "@/components/commoncomponents/HeaderComponent.vue";
import "@/assets/css/mil-pricing.css";
import { SAMPLE_CSV } from "../PricingJs/data";
import { parseCSV } from "../PricingJs/engine";
import ComplianceCard from "../MILComo/ComplianceCard.vue";

const emit = defineEmits(["run"]);
const csvText = ref("");
const fileRef = ref(null);
const { proxy } = getCurrentInstance(); 
const headerText = ref('Lot Pricing Optimizer');
const snackbar = reactive({
        visible: false,
        text: '',
        color: '',
        icon: '',
        timeout: 2000,
        position: 'top',
        mode: 'multi-line'
    });

const loadFile = (file) => {
  if (!file) return;
  const reader = new FileReader();
  reader.onload = (e) => (csvText.value = e.target.result || "");
  reader.readAsText(file);
};

const minItems = ref(null);
const maxItems = ref(null);
const minValue = ref(null);
const maxValue = ref(null);

const handleRun = () => {
  // if (
  //   minItems.value === null || minItems.value === "" ||
  //   maxItems.value === null || maxItems.value === "" ||
  //   minValue.value === null || minValue.value === "" ||
  //   maxValue.value === null || maxValue.value === ""
  // ) {
  //   snackbar.visible = true;
  //   snackbar.color = "error";
  //   snackbar.icon = "mdi-alert";
  //   snackbar.text = "Please enter the values";
  //   return;
  // }

  if ((Number(maxItems.value) < Number(minItems.value))) {
    snackbar.visible = true;
    snackbar.color = "error";
    snackbar.icon = "mdi-alert";
    snackbar.text = "Max items must be greater than Min items";
    return;
  }
  // if (Number(maxValue.value) < Number(minValue.value)) {
  //   snackbar.visible = true;
  //   snackbar.color = "error";
  //   snackbar.icon = "mdi-alert";
  //   snackbar.text = "Max value must be greater than Min value";
  //   return;
  // }

  if (csvText.value) {
    emit("run", parseCSV(csvText.value), {
      minItems: Number(minItems.value),
      maxItems: Number(maxItems.value),
      minValue: Number(minValue.value),
      maxValue: Number(maxValue.value)
    });
  }
};

const useSample = () => {
  if (
    minItems.value === null || minItems.value === "" ||
    maxItems.value === null || maxItems.value === "" ||
    minValue.value === null || minValue.value === "" ||
    maxValue.value === null || maxValue.value === ""
  ) {
    snackbar.visible = true;
    snackbar.color = "error";
    snackbar.icon = "mdi-alert";
    snackbar.text = "Please enter the values";
    return;
  }
  
  if (Number(maxItems.value) <= Number(minItems.value)) {
    snackbar.visible = true;
    snackbar.color = "error";
    snackbar.icon = "mdi-alert";
    snackbar.text = "Max items must be greater than Min items";
    return;
  }
  if (Number(maxValue.value) <= Number(minValue.value)) {
    snackbar.visible = true;
    snackbar.color = "error";
    snackbar.icon = "mdi-alert";
    snackbar.text = "Max value must be greater than Min value";
    return;
  }

  csvText.value = SAMPLE_CSV;
  emit("run", parseCSV(SAMPLE_CSV), {
      minItems: Number(minItems.value),
      maxItems: Number(maxItems.value),
      minValue: Number(minValue.value),
      maxValue: Number(maxValue.value)
  });
};

const downloadFile = () => {
       let url;
       url = "/api/v2/warehouse/inventory_file_uploads/download_competitive_liquidations";
       proxy.$httpSecured
       .post(url,{"liquidation":{
              "ids":[]
            }})
       .then(response => {
         if (response.data) {
             snackbar.visible = true;
            snackbar.color = "success";
            snackbar.icon = "mdi-check-circle";
            snackbar.mode = "multi-line";
            snackbar.position = "top";
            snackbar.timeout = 3000;
            snackbar.title = "Success";
            snackbar.text = response.data.message;
         }
       })
       .catch(error => {
        snackbar.visible = true;
        snackbar.color = "success";
        snackbar.icon = "mdi-check-circle";
        snackbar.mode = "multi-line";
        snackbar.position = "bottom";
        snackbar.timeout = 3000;
        snackbar.title = "Success";
        snackbar.text = error.response.data.message;
       })
    }

    const getRouterLink = () => {
      return {name: 'liquidationNew' };
    };
</script>

<template>
  <header-component :headerTitle="headerText" :router-link="getRouterLink()" router-link-text="Liquidation" :return-condition="true" component-name="Lot Pricing Optimizer"/>
  <div class="landing-page" style="justify-content: center">
    <div style="text-align: center; margin-bottom: 40px; position: relative; z-index: 1; color: white">
      <div style="display: inline-flex; align-items: center; gap: 10px; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); border-radius: 100px; padding: 8px 24px; margin-bottom: 20px">
          <div style="width: 8px; height: 8px; border-radius: 50%; background: #00d09c; box-shadow: 0 0 10px rgba(0, 208, 156, 0.5)" />
          <span style="font-size: 11px; letter-spacing: 0.2em; font-weight: 800">AI PRICING INTELLIGENCE</span>
      </div>
      <h1 style="font-size: 72px; font-weight: 800; margin: 0; letter-spacing: -0.04em">
        Lot Pricing <span style="color: #3b82f6">Optimizer</span>
      </h1>
      <p style="margin-top: 24px; color: rgba(255,255,255,0.7); font-size: 19px; max-width: 640px; margin-left: auto; margin-right: auto; line-height: 1.6">
        Transform inventory into optimized lots with Blubirch MIL engine. Maximize recovery with AI-driven pricing.
      </p>
    </div>
    <div class="landing-card-container">
      <div class="card" style="padding: 40px; text-align: center; margin: 0">
        <div class="upload-zone" @click="fileRef.click()">
          <input ref="fileRef" type="file" style="display: none" @change="(e) => loadFile(e.target.files[0])" />
          <div style="font-size: 48px; color: #0067ff; margin-bottom: 20px">📄</div>
          <div style="font-weight: 800; font-size: 22px; color: #1e293b">{{ csvText ? "CSV Ready to Process" : "Drop your inventory CSV here" }}</div>
          <div style="font-size: 14px; color: #94a3b8; margin-top: 8px">Support formats: .csv, .xlsx, .txt</div>
        </div>

        <div style="margin-top: 24px; text-align: left;">
          <h3 style="font-size: 16px; font-weight: 700; color: #1e293b; margin-bottom: 12px;">1. Number of items per lot</h3>
          <div style="display: flex; gap: 16px; margin-bottom: 20px;">
            <div style="flex: 1;">
              <label style="font-size: 14px; color: #64748b; font-weight: 600; margin-bottom: 4px; display: block;">Min</label>
              <input type="number" v-model="minItems" style="width: 100%; padding: 12px; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 16px;" placeholder="Min Items" />
            </div>
            <div style="flex: 1;">
              <label style="font-size: 14px; color: #64748b; font-weight: 600; margin-bottom: 4px; display: block;">Max</label>
              <input type="number" v-model="maxItems" style="width: 100%; padding: 12px; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 16px;" placeholder="Max Items" />
            </div>
          </div>

          <h3 style="font-size: 16px; font-weight: 700; color: #1e293b; margin-bottom: 12px;">2. Value of lot</h3>
          <div style="display: flex; gap: 16px; margin-bottom: 20px;">
            <div style="flex: 1;">
              <label style="font-size: 14px; color: #64748b; font-weight: 600; margin-bottom: 4px; display: block;">Min</label>
              <input type="number" v-model="minValue" style="width: 100%; padding: 12px; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 16px;" placeholder="Min Value" />
            </div>
            <div style="flex: 1;">
              <label style="font-size: 14px; color: #64748b; font-weight: 600; margin-bottom: 4px; display: block;">Max</label>
              <input type="number" v-model="maxValue" style="width: 100%; padding: 12px; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 16px;" placeholder="Max Value" />
            </div>
          </div>
        </div>

        <div style="display: flex; gap: 16px; margin-top: 24px">
          <button class="btn btn-outline" style="flex: 1; padding: 18px; border-radius: 16px" @click="downloadFile">Download Inventory & Upload</button>
          <button class="btn btn-primary" style="flex: 1.5; padding: 18px; border-radius: 16px" :disabled="!csvText" @click="handleRun">Generate Pricing Model →</button>
        </div>
      </div>
      <ComplianceCard :dark="false" />
    </div>
  </div>
  <v-snackbar
            v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
            <v-layout align-center pr-4>
                <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
                <v-layout column>
                <div>{{ snackbar.text }}</div>
                </v-layout>
            </v-layout>
            <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
                <v-icon>clear</v-icon>
            </v-btn>
        </v-snackbar>
</template>
